import React from 'react';

import { ManagementFieldDisplay } from '@components/ManagementFieldDisplay';

export const InstructionFieldDisplay: typeof ManagementFieldDisplay = (props) => (
  <ManagementFieldDisplay {...props} variant="light" />
);
